var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 9 6","fill":"none"}},[_c('path',{attrs:{"id":"Polygon 1","d":"M4.2 6L0.0430769 7.83039e-07L8.35692 5.62197e-08L4.2 6Z","fill":_vm.color_prop}})])}
var staticRenderFns = []

export { render, staticRenderFns }